var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"part part_about"},[_c('el-row',[_c('el-col',{staticClass:"about_center",attrs:{"xs":24,"sm":24}},[_c('img',{attrs:{"src":_vm.aboutImg[0].img}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }